import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './KanemFazaPartnership.scss';
import SEO from '../../components/SEO';

const KanemFazaPartnership = () => {
    const { t } = useTranslation();
    const [ready, setReady] = useState(false);
    const sectionsRef = useRef([]);

    useEffect(() => {
        window.scrollTo(0, 0);
        const timer = setTimeout(() => setReady(true), 150);
        const obs = new IntersectionObserver(
            entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('kfp-visible'); }),
            { threshold: 0.08 }
        );
        sectionsRef.current.forEach(el => el && obs.observe(el));
        return () => { clearTimeout(timer); obs.disconnect(); };
    }, []);

    const addRef = i => el => { sectionsRef.current[i] = el; };

    const offers = t('faza.offers', { returnObjects: true });

    return (
        <div className="kfp-page">
            <SEO
                title="Partenariat KANEM × FAZA"
                description="KANEM s'associe à FAZA pour offrir un accompagnement complet en orientation à l'étranger, visa et permis de séjour."
                url="/kanem/partenariat-faza"
            />

            {/* ── HERO ─────────────────────────────────────────────── */}
            <section className="kfp-hero">
                <div className="kfp-hero-grid" aria-hidden="true">
                    {[...Array(48)].map((_, i) => <div key={i} className="kfp-hero-cell" />)}
                </div>
                <div className="kfp-hero-content">
                    <p className={`kfp-eyebrow ${ready ? 'kfp-in' : ''}`}>
                        {t('faza.eyebrow')}
                    </p>
                    <h1 className={`kfp-hero-title ${ready ? 'kfp-in' : ''}`}>
                        <span className="kfp-brand">KANEM</span>
                        <span className="kfp-times" aria-hidden="true">×</span>
                        <span className="kfp-brand kfp-brand--faza">FAZA</span>
                    </h1>
                    <p className={`kfp-hero-sub ${ready ? 'kfp-in' : ''}`}>
                        {t('faza.hero_sub')}
                    </p>
                </div>
            </section>

            {/* ── WHAT IS THIS ─────────────────────────────────────── */}
            <section className="kfp-intro kfp-reveal" ref={addRef(0)}>
                <div className="kfp-inner">
                    <div className="kfp-intro-grid">
                        <div className="kfp-intro-label">
                            <span>{t('faza.intro_label')}</span>
                        </div>
                        <div className="kfp-intro-body">
                            <h2>{t('faza.intro_title')}</h2>
                            <p>{t('faza.intro_body')}</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* ── WHAT WE OFFER ────────────────────────────────────── */}
            <section className="kfp-offers kfp-reveal" ref={addRef(1)}>
                <div className="kfp-inner">
                    <p className="kfp-section-label">{t('faza.offers_label')}</p>
                    <h2 className="kfp-section-title">{t('faza.offers_title')}</h2>
                    <div className="kfp-offer-list">
                        {Array.isArray(offers) && offers.map((offer, i) => (
                            <div className="kfp-offer-item" key={i}
                                style={{ transitionDelay: `${i * 0.1}s` }}>
                                <span className="kfp-offer-icon">{offer.icon}</span>
                                <div>
                                    <h3>{offer.title}</h3>
                                    <p>{offer.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ── CTA ──────────────────────────────────────────────── */}
            <section className="kfp-cta kfp-reveal" ref={addRef(2)}>
                <div className="kfp-inner kfp-cta-inner">
                    <div className="kfp-cta-line" aria-hidden="true" />
                    <h2>{t('faza.cta_title')}</h2>
                    <p>{t('faza.cta_sub')}</p>
                    <div className="kfp-cta-actions">
                        <a
                            href="https://cspfaza.com/kanem/services"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="kfp-btn-primary"
                        >
                            {t('faza.cta_btn')}
                            <span className="kfp-btn-arrow">↗</span>
                        </a>
                        <Link to="/" className="kfp-btn-ghost">
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default KanemFazaPartnership;
